<template>
  <div id="app" :class="{'map-full-size': mapFullSize}">
    <message-screen v-if="messageScreen" @close="messageScreen=false" :msg-titulo="msgTitulo" :msg-sub-titulo="msgSubTitulo" :msg-icon-class="msgIconClass"/>
    <procesando-screen v-if="ProcessScreen"/>

    <header class="container app-header">
      <hamburger-menu @tabChange="changeTab" :ParamInputClose="boolCloseMenu"/>
      <img class="header-icon" src="/img/logo-header.png" alt=""/>
      <h1>Vigilancia Ambiental</h1>     
    </header>
            
    <div class="content-toggle-button" @click="mapFullSize = !mapFullSize">
    </div>
    <card data-card-map="map-card">
      <esri-map ref="esri_map" @EventLoadMapComplete="onLoadMapComplete" @AppViewEstXY="onViewEstXY" @chartsToggle="mapFullSize = !mapFullSize" />
    </card>
    <div class="main-card-arrange card-arrange">
      <!--   Pagina de Localización de Direcciones   -->
      <vigilancia-ambiental v-if="cartografia" data-grid-column-span="2" v-show="currentTab === 0" @EventZoomElementoEnMapa="setZoomElementoEnMapa" :WatchCodigo="ParamCodigo"/>        
    </div>
  </div>
</template>

<script>
import GlobalVars from './utils/global_vars';
import {xmlListToJson, getWebServiceSoap, setTrim, xml2json} from "@/helpers/xmlhelper";
import LoginScreen from "./components/LoginScreen";
import MessageScreen from "./components/MessageScreen";
import EsriMap from './components/EsriMap.vue';
import CardView from "@/components/CardView.vue";
import {getFeaturesExtent} from './utils/arcgis_utilities';
import {getFeatures} from './utils/arcgis_utilities';
import {addFeatureToView, addSvgToView} from './utils/arcgis_utilities';
import VigilanciaAmbiental from "./components/VigilanciaAmbiental.vue";
import HamburgerMenu from "./components/HamburgerMenu";
import SplashScreen from "./components/SplashScreen";
import ProcesandoScreen from "./components/ProcesandoScreen";
import {loadModules} from "esri-loader";
import {arcgisConfig} from '@/config';


const arcgisModules = loadModules([
    // Geometry
    "esri/geometry/Extent",
    "esri/geometry/Point",
    "esri/geometry/SpatialReference",
    "esri/tasks/PrintTask", 
    "esri/tasks/support/PrintTemplate",
    "esri/tasks/support/PrintParameters",
    "esri/layers/FeatureLayer",
], arcgisConfig.loaderOptions).then( ([
      Extent,Point,SpatialReference,PrintTask,PrintTemplate,PrintParameters,FeatureLayer
  ]) => {
    return {
      Extent,Point,SpatialReference,PrintTask,PrintTemplate,PrintParameters,FeatureLayer
    };
});

Number.prototype.numberWithCommas = function() {
    return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};


export default {
  name: 'App',
  data(){
    return {
      ParamReg:{},
      loadMapComplete:false,
      ParamCodigo:null,
      ParamUrl:{},

      ParamWatchXY:null,
      login:true,
      messageScreen:false,
      splashScreen: true,
      ProcessScreen: false,
      cartografia:true,
      results: null,
      coorXY:[],
      msgTitulo:'',
      msgSubTitulo:'',
      msgIconClass:'message-icon-error',
      wsGrabar:false,
      lastResultOptions: null,
      mapFullSize: false,
      currentTab: 0,
      activeRed:1,
      boolCloseMenu:-1,
    }
  },
  components: {
    MessageScreen,
    VigilanciaAmbiental,
    SplashScreen,
    ProcesandoScreen,
    HamburgerMenu,
    EsriMap,
    Card: CardView
  },
  created(){  
    //--Obtenemos los datos del URl
      var currentUrl = window.location.search;
      var queryDict = {}
      currentUrl.substr(1).split("&").forEach(function(item){
            queryDict[item.split("=")[0].toLowerCase()] = item.split("=")[1]
      })
      //--LLenamos las Variables globales
      if (queryDict.hasOwnProperty('sistema')){
        this.$globalVar.PUBLIC_NUM_SISTEMA=queryDict.sistema
        this.$globalVar.PUBLIC_NOM_SISTEMA= arcgisConfig.APP_ORIGEN.find( s => s.id === Number(queryDict.sistema)).app;
        this.$globalVar.APP_USER_CONNECT  = this.$globalVar.PUBLIC_NOM_SISTEMA;
        this.login = false;
        };
      if (queryDict.hasOwnProperty('codgis')){this.$globalVar.APP_DIR_NRO=queryDict.codgis};
      if (queryDict.hasOwnProperty('codext')){this.$globalVar.APP_DIR_GEO=queryDict.codext};
  },
  watch: {
    messageScreen(nuevoValor, antiguo){
      if (!nuevoValor && this.wsGrabar){
          this.onWsInvoke();
          console.log('Se Grabo OK')
      }
    },     
  },
  methods: {
    onCloseLoginWindow(){
    
    },
    onCloseWindow(){
      console.log('Se cierra el Mapa')
      var ventana=window.parent.self;
          ventana.opener=window.parent.self;
          ventana.close();
    },
    showWindowProcess(estado){
      this.ProcessScreen = estado;
    },
    showMessage(options){
      this.msgTitulo = options.titulo;
      this.msgSubTitulo = options.subtitulo;
      this.msgIconClass = options.iconClass;
      this.messageScreen = true;
    },
    async onViewDireccionXY(mapPoint){
      if (this.messageScreen == false){
          this.currentTab = 0;
          this.direccionXY =true;
          this.cartografia =false;
          const {Point} = await arcgisModules; 
          const oPoint = new Point;
                oPoint.x = mapPoint.longitude;
                oPoint.y = mapPoint.latitude;               
          //--Dibujamos el Punto en el Mapa
          const feature = {geometry:{type:oPoint.type, 
                                     extent:oPoint.extent,
                                     x:oPoint.x,
                                     y:oPoint.y,},
                                     spatialReference:oPoint.spatialReference}
          this.showPointInMap(feature);
          this.ParamWatchXY = mapPoint;
      }
    },
    onViewAvveXY(mapPoint){
      if (this.messageScreen == false){
          this.coorXY = mapPoint;
          this.currentTab = 4;
      }
    },
    async onViewXY(CoorXY){
        const {Point} = await arcgisModules; 
        const oPoint = new Point;
              oPoint.x = CoorXY.COOR_X;
              oPoint.y = CoorXY.COOR_Y;
          //--Dibujamos el Punto en el Mapa
          const feature = {geometry:{type:oPoint.type, 
                                     extent:oPoint.extent,
                                     x:oPoint.x,
                                     y:oPoint.y,},
                                     spatialReference:oPoint.spatialReference}
          this.showPointInMap(feature);
    },
    async showPointInMap(feature){
      const {Extent} = await arcgisModules;
      const oView = this.$refs.esri_map.view;
      oView.graphics.removeAll();
      //--Definimos el Extent Inicial del Primer Feature
      let featuresExtent = this.getExtent(feature, Extent);
      await addSvgToView({feature:feature, view:oView,});
      let oExtent = featuresExtent.extent.clone().expand(1.5);
      oView.extent = oExtent;

      //--Obtenemos los datos de Red
      const urlWs = arcgisConfig.WS_SIGFFTT + "/WSSIGFFTT_FFTT_COBERTURA";
      const WsParam =  `NUM_COD_CDX=${feature.geometry.x}&NUM_COD_CDY=${feature.geometry.y}`
      const xmlTextPOST = await getWebServiceSoap(urlWs, WsParam);    
      console.log(xmlTextPOST);
      const WsResult = xml2json(xmlTextPOST)

      //--ViewPopup
      oView.popup.close();
      oView.popup.open({
        title:'Información de Red',
        content:"<table class='tbl-info'>"+
                "<tr><td colspan=2 class='tbl-info-tr'><p class='tbl-info-p'>RED TELEFONIA FIJA</p></td></tr>" +
                "<tr><td class='tbl-info-td'><p class='tbl-info-p'>Planta</p></td><td><p class='tbl-info-p'>" +  WsResult.STR_EXISTE_COBRE + "</p></td></tr>" + 
                "<tr><td class='tbl-info-td'><p class='tbl-info-p'>Armario Fraude</p></td><td><p class='tbl-info-p'>" +  WsResult.STR_ARM_FRAUDE + "</p></td></tr>" + 
                "<tr><td colspan=2 class='tbl-info-tr'><p class='tbl-info-p'>RED HFC</p></td></tr>" +
                "<tr><td class='tbl-info-td'><p class='tbl-info-p'>Planta</p></td><td><p class='tbl-info-p'>" +  WsResult.STR_EXISTE_COAXIAL + "</p></td></tr>" + 
                "<tr><td class='tbl-info-td'><p class='tbl-info-p'>HFC:</p></td><td><p class='tbl-info-p'>" +  WsResult.STR_EXISTE_HFC + "</p></td></tr>" + 
                "<tr><td class='tbl-info-td'><p class='tbl-info-p'>Cobertura:</p></td><td><p class='tbl-info-p'>" +  WsResult.STR_EXISTE_DIG + "</p></td></tr>" + 
                "</table>",
        location: oView.center,
        collapsed:false,
      });
    },

    showResults(data, options){
      console.log(options);
      this.results = data;
      this.lastResultOptions = options;
      this.$refs.chart_gauge1.randomize();
      this.$refs.chart_line.randomize();
      setTimeout( () => {
        this.$refs.table_results_container.$el.scrollIntoView({block: "start", behavior: "smooth"});
      }, 1500);
    },
    async showInMap(row) {
      console.log(this.$refs.esri_map.view.map);
      const results = await getFeaturesExtent({
        serviceUrl: this.lastResultOptions.serviceUrl.toString(),
        where: `OBJECTID=${row['OBJECTID']}`,
      });
      console.log(results);
    },
    async onLoadMapComplete(){
      this.loadMapComplete = true;
      this.setZoomElementoEnMapa(this.ParamReg,false);
    },
    async onViewEstXY(mapPoint){
      console.log(mapPoint);
      //--Set en el Focus del texto
      var divDatos = document.getElementById("divDatos");
      divDatos.scrollIntoView();

      const {FeatureLayer} = await arcgisModules;
      const layer = new FeatureLayer({title:'vigamb', id:0, url:"https://pifa.oefa.gob.pe/arcgis/rest/services/VIG_MON/SERV_VIGILANCIA_AMBIENTAL_PROD/MapServer/0"});
      layer.queryFeatures({
            geometry: mapPoint,
            distance: 50,
            units: "kilometers",
            spatialRelationship: "intersects",
            returnGeometry: true,
            returnQueryGeometry: true,
            outFields: ["*"],
      }).then((featureSet) => {
			  var distanciaFinal = 1000000;
			  var CodigoEstacion = '';
			  featureSet.features.forEach((result, index) => {
				  const pointTo = result.geometry;
				  const attributes = result.attributes;
				  console.log(attributes)
				  // Measure distance and output result to console log
				  var distanceUnits = this.getKilometros(mapPoint.latitude, mapPoint.longitude,pointTo.latitude,pointTo.longitude)
				  //console.log(distanceUnits);
				  if (Number(distanceUnits) < Number(distanciaFinal)){ 
					  distanciaFinal = distanceUnits;
					  CodigoEstacion = attributes.COD_EST
				  }
			  });
			  if (featureSet.features.length > 0){
          this.ParamCodigo = CodigoEstacion;
			  };
      });
    },
    getKilometros(lat1,lon1,lat2,lon2){
		  var R = 6371; //Radio de la tierra en km
		  var dLat = this.rad( lat2 - lat1 );
		  var dLong = this.rad( lon2 - lon1 );
		  var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(this.rad(lat1)) * Math.cos(this.rad(lat2)) * Math.sin(dLong/2) * Math.sin(dLong/2);
		  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		  var d = R * c;
		  return d.toFixed(3); //Retorna tres decimales
	  },
    rad(x){
      return x*Math.PI/180;
    },
    async setZoomElementoEnMapa(row,ZoomIn=true){
      this.ParamReg = row;
      //--Si el Mapa no se ha cargado no realizar nada
      if (!this.loadMapComplete){return;}

      //--Cargamos la Libreria
      const {Extent} = await arcgisModules;
      //--Array de Features
      let featuresResult = {};
        
      const oView = this.$refs.esri_map.appConfig.activeView;
      oView.graphics.removeAll();

      const results = await getFeatures({
            serviceUrl: row.url,
            outFields: ['*'],
            where: row.where,
            withRelationship:row.rel,
            returnGeometry:true,
      });

      //--Si la busqueda es con relación se debe crear un nuevo resultado con los features
      if(row.rel){
        featuresResult.features = [];
        //--Resultado tiene relation y solo debemos extraer los Features
        Object.keys(results).forEach(function(fSetKey){
          // --Recorremos todos los Features
          results[fSetKey].features.forEach(function(f){
            featuresResult.features.push(f);
          });
        });
      }else{
        //--El resultado no tiene relación
        featuresResult = results;
      }

      if (featuresResult.features.length > 0){
          //--Elavamoramos un PopupTemplate Personalizado
          var content = [{ type: "fields",fieldInfos: []}, {type: "media", mediaInfos: [] }]
          featuresResult.fields.forEach(function (field){
            if (field.type !== 'esriFieldTypeOID'  && field.type !== 'esriFieldTypeGeometry' && 
                field.type !== 'esriFieldTypeBlob' && field.type !== 'esriFieldTypeRaster'   &&
                field.type !== 'esriFieldTypeGUID' && field.type !== 'esriFieldTypeGlobalID' && 
                field.type !== 'esriFieldTypeXML') {
              if (field.alias.toUpperCase().substr(0, 10)=='FOTOGRAFÍA') {
                  content[1].mediaInfos.push({
                    type: "image",
                    title: field.alias,
                    value: {
                    sourceURL: '{' + field.name + '}'}                                        
                    });
              } else  if (field.alias.toUpperCase() !='OBJECTID') {
                    content[0].fieldInfos.push({
                      fieldName: field.name, 
                      visible: true,  
                      label: field.alias + ': '  
                    });
              }
            }
          });
          var result = featuresResult.features[0];
          result.popupTemplate = { title: "{NOMB_ESTACION}", content: content };

          //--Definimos el Extent Inicial del Primer Feature
          let featuresExtent = this.getExtent(featuresResult.features[0], Extent);
          for (const f in featuresResult.features) {         
            //--Creamos el Grafico en el Mapa
            const oFeature = featuresResult.features[f]
            if(oFeature.geometry.type=='point'){
                await addSvgToView({feature:oFeature, view:oView, oSize:"30px", oWidth:3});
                await addSvgToView({feature:oFeature, view:oView, oSize:"41px", oWidth:2});
                await addSvgToView({feature:oFeature, view:oView, oSize:"50px", oWidth:1});
             }else{ 
                await addFeatureToView({feature:featuresResult.features[f], view:oView,});
             }          
            //--Creamos un Extent de todos los Features
            const featureExtent = this.getExtent(featuresResult.features[f], Extent);
            featuresExtent = featuresExtent.union(featureExtent) 
          }
          if (ZoomIn){
            let oExtent = featuresExtent.extent.clone().expand(6.5);
            oView.extent = oExtent;
            //--Visualiza el Popup
            oView.popup.open({
                features: [result],
                location: result.geometry
            });
          }
          //}
      }else{
         console.log('No hay Registros');
      }
    },
    getExtent(feature, Extent){
      //--Traemos el Extent del Feature
      let featureExtent = feature.geometry.extent;
      if(!featureExtent){
        if(feature.geometry.type=='point'){
            var nExtentFactor = 0.000920675/2;
            //Si no hay Extent creamos uno en base a las coordenadas
            featureExtent = new Extent(feature.geometry.x + nExtentFactor,feature.geometry.y + nExtentFactor,feature.geometry.x - nExtentFactor, feature.geometry.y - nExtentFactor,feature.spatialReference);
            return featureExtent;
        }else{
            //Si no hay Extent creamos uno en base a las coordenadas
            featureExtent = new Extent(feature.geometry.x,feature.geometry.y,feature.geometry.x,feature.geometry.y,feature.spatialReference);
        }
      }
       return featureExtent.clone().expand(1); 
    },
    changeTab(tabId){
      this.activeRed = (tabId>0 && tabId<4) ? 1: 0;
      this.currentTab = tabId;
      if (tabId==0){
          this.cartografia =true;
          this.direccionXY =false;        
      };
      this.mapFullSize = false;
      this.boolCloseMenu = tabId+1;
    }
  },
}
</script>

<style lang="scss">
  @import "./assets/styles/global.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>